<template>
  <a :href="href" :class="classes">
    <slot />
  </a>
</template>

<script>
const BASE_CLASS_NAME = 'link';

export default {
  name: 'ui-link',

  props: {
    href: {
      type: String,
      required: true,
    },
    color: {
      validator(value) {
        return ['blue', 'white', 'black'].indexOf(value) !== -1
      },
      default: 'blue'
    },
    underline: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return [
        `${BASE_CLASS_NAME}`,
        `${BASE_CLASS_NAME}_color_${this.color}`,
        { [`${BASE_CLASS_NAME}_underline`]: this.underline },
      ]
    },
  },
};
</script>

<style lang="scss">
  .link {
    &_color {
      &_blue {
        color: $blue;
      }
      &_white {
        color: $white;
      }
      &_black {
        color: $black;
      }
    }

    &_underline {
      text-decoration: underline;
    }
  }
</style>